export tag TopMenu
	def render
		<self>
			<a
				.topmenuitem
				route-to="/"
			> "Home"

	css .topmenuitem cursor:pointer c:#fff va:middle ta:center margin:4rem auto fs:1rem fw:bold d:block td:none
		&:hover td:line-through
